

import React from "react";


/**
 * 
 * @param {{ columns: { title: string, width: number }[], rows: Function[][], height: number }} param0 
 */
export function ScrollingTable({ columns, rows, height, onRowClick, scrollX = false, freezeColumn1 = false, header = "", footer = "" }) {
    const clickable = onRowClick ? true : false;
    const totalWidth = scrollX ? columns.reduce((a, b) => a + Number(b.width.split("px")[0]), 0) : undefined;

    // return <div key={Math.random()} className={"table-scrolling" + (scrollX ? " scroll-x" : "")}>
    // {header}
    //     <div className={"table-scrolling-header" + (clickable ? " row-clickable" : "") }>
    //         <div className="table-row">{columns.map(({ title, width }, i) => 
    //             <div className="table-cell" key={`table-header-col-${i}`} style={width ? { width } : {}}>{title}</div>
    //         )}</div>
    //     </div>
    //     <div style={{ height }} className="table-scrolling-body-wrapper">
    //         <div className={ "table-scrolling-body" + (clickable ? " row-clickable" : "") }>
    //             {rows.map((cells, i) => {
    //                 return <div className="table-row" key={`table-row-${i}`} onClick={clickable ? () => onRowClick(i) : undefined} style={{ width: scrollX ? totalWidth + "px" : "100%" }}>
    //                     {cells.map((cell, i) => {
    //                         const width = columns[i].width;
    //                         return <div className={"table-cell" + (i === 0 ? " table-cell-1" : "")} key={`table-row-cell-${i}`} style={width ? { width } : {}}>{cell}</div>
    //                     })}
    //                 </div>
    //             })}
    //         </div>
    //     </div>
    //     {footer}
    // </div>;

    const headerScrollRef = React.createRef();
    const onScroll = (e) => {
        /** @type {HTMLDivElement} */
        const element = e.target;
        
        const horizontalScroll = element.scrollLeft;
        headerScrollRef.current.style.left = -horizontalScroll + "px";
    };

    return <div key={Math.random()} className={"table-scrolling" + (scrollX ? " scroll-x" : "")} >
        {header}
        <div className="table-header-wrapper">
            <div className="table-wrapper-inner" ref={headerScrollRef}>
                <div className="table-row header-row" style={{ width: totalWidth }}>
                    {columns.map(({ title, width }, i) => 
                        <div className="table-cell header-cell" key={`header-cell-${i}`} style={width ? { width } : {}}>{title}</div>
                    )}
                </div>
            </div>
        </div>
       
        <div className={"table-wrapper-horizontal" +  (clickable ? " row-clickable" : "") } onScroll={onScroll}>
            <div className="table-wrapper-inner">
                <div className="table-rows" style={{ height }}>
                    {rows.map((cells, i) => {
                        return <div className="table-row" key={`table-row-${i}`} onClick={clickable ? () => onRowClick(i) : undefined} style={{ width: totalWidth }}>
                            {cells.map((cell, i) => {
                                const width = columns[i].width;
                                return <div className={"table-cell" + (i === 0 ? " table-cell-1" : "")} key={`table-row-cell-${i}`} style={width ? { width } : {}}>{cell}</div>
                            })}
                            
                        </div>
                    })}
                </div>
            </div>
        </div>
        {footer}
    </div>;
}